import {
    Datagrid,
    EditButton,
    DeleteButton,
    List,
    Show,
    SimpleShowLayout,
    TextField,
    Pagination,
    SelectField,
    SelectInput,
    Create,
    ReferenceArrayField,
    ReferenceArrayInput,
    BooleanField,
    TopToolbar,
} from "react-admin";
import { Edit, SimpleForm, TextInput } from "react-admin";
import { VisibilityBulkActionButtons } from "./common";
import { LongDateField, SaveAndAddAnotherToolbar, ShortDateField } from "./customFields";

export const CMS_PERMISSION_TYPES = [
    { id: "cms_reader", name: "📖 CMS Reader" },
    { id: "cms_writer", name: "✍️ CMS Writer" },
    { id: "cms_external", name: "🚋 CMS External (Reader)" },
];

export const ALL_PERMISSION_TYPES = [...CMS_PERMISSION_TYPES, { id: "superuser", name: "🧙 Superuser" }];

const filters = [<TextInput source="q" label="Search" alwaysOn />];

export const CMSPermissionList = () => (
    <List
        filters={filters}
        perPage={50}
        pagination={<Pagination rowsPerPageOptions={[25, 50, 100, 200]} />}
        sort={{ field: "created_at", order: "DESC" }}
    >
        <Datagrid rowClick="show" bulkActionButtons={<VisibilityBulkActionButtons />}>
            <TextField source="email" />
            <SelectField source="type" label="Type" choices={ALL_PERMISSION_TYPES} />
            <ReferenceArrayField
                source="distributor_ids"
                reference="distributors"
                label="Distributors"
                sortable={false}
            />
            <BooleanField source="activated" sortable={false} />
            <ShortDateField source="created_at" label="Created at" />
            <EditButton />
        </Datagrid>
    </List>
);

const CMSPermissionShowActions = () => (
    <TopToolbar>
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
    </TopToolbar>
);

export const CMSPermissionShow = () => (
    <Show actions={<CMSPermissionShowActions />}>
        <SimpleShowLayout>
            <h2>CMS Permission Details</h2>

            <TextField source="email" />
            <SelectField source="type" label="Type" choices={ALL_PERMISSION_TYPES} />
            <ReferenceArrayField source="distributor_ids" reference="distributors" />
            <BooleanField source="activated" />
            <TextField source="user_id" />
            <LongDateField source="created_at" label="Created at" />
            <TextField source="id" />
        </SimpleShowLayout>
    </Show>
);

export const CMSPermissionCreate = () => (
    <Create>
        <SimpleForm toolbar={<SaveAndAddAnotherToolbar />} style={{ width: "500px" }}>
            <h2>Create CMS Permission</h2>

            <TextInput source="email" fullWidth />
            <SelectInput source="type" label="Type" choices={CMS_PERMISSION_TYPES} fullWidth />
            <ReferenceArrayInput source="distributor_ids" reference="distributors" />
        </SimpleForm>
    </Create>
);

export const CMSPermissionEdit = () => (
    <Edit mutationMode="pessimistic">
        <SimpleForm toolbar={<SaveAndAddAnotherToolbar />}>
            <h2>Edit CMS Permission</h2>

            <SelectInput source="type" label="Type" choices={CMS_PERMISSION_TYPES} />
            <ReferenceArrayInput source="distributor_ids" reference="distributors" />
        </SimpleForm>
    </Edit>
);
